module.exports = __webpack_public_path__ + "img/congwu.e05912b4.png";